module.exports = __webpack_public_path__ + "img/3_6.0cd1b157.png";